import { AuthTokens } from 'types/auth.ts'

// TAGS
export enum TagTypes {
  ACCOUNT = 'account',
  CONTACT = 'contact',
  OPPORTUNITY = 'opportunity',
  CASE = 'case',
  EVENT = 'event',
  CONSUMPTION = 'consumption',
  METER_READINGS = 'meter-readings',
  EVENT_LOGS = 'event-logs'
}

// REFRESH TOKENS

export type RefreshTokensResponse = {
  tokens: AuthTokens
}
